import { Link, useLocation } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

// The one admin header: a "← Back to dashboard" link plus the core nav row,
// shown on every admin page so Meghana can jump between sections without
// returning to the dashboard each time. The current section is highlighted.
const NAV = [
  { to: "/admin/dashboard", label: "Dashboard" },
  { to: "/admin/verify", label: "Verification Queue" },
  { to: "/admin/sweep-review", label: "Wording review" },
  { to: "/admin/catalog", label: "Medication catalogue" },
  { to: "/admin/products", label: "Products" },
  { to: "/admin/courses", label: "Course Tracker" },
  { to: "/admin/medication-guidance", label: "Medication notes" },
  { to: "/admin/alternatives", label: "What to use instead" },
  { to: "/admin/report-templates", label: "Report Templates" },
];

export default function AdminHeader() {
  const { pathname } = useLocation();
  return (
    <div className="mb-6" data-testid="admin-header">
      <Link
        to="/admin/dashboard"
        data-testid="admin-header-back"
        className="inline-flex items-center gap-1.5 text-sm text-stone-600 hover:text-stone-900"
      >
        <ArrowLeft className="h-4 w-4" /> Back to dashboard
      </Link>
      <nav
        data-testid="admin-header-nav"
        className="mt-3 flex flex-wrap items-center gap-1.5 border-b border-stone-200 pb-3"
      >
        {NAV.map((n) => {
          const active = pathname === n.to || pathname.startsWith(`${n.to}/`);
          return (
            <Link
              key={n.to}
              to={n.to}
              data-testid={`admin-nav-${n.to.split("/").pop()}`}
              className={`rounded-full px-3 py-1 text-xs font-medium transition-colors ${
                active ? "bg-stone-900 text-white" : "text-stone-600 hover:bg-stone-200/70"
              }`}
            >
              {n.label}
            </Link>
          );
        })}
      </nav>
    </div>
  );
}
